import React from 'react';
import styled from 'styled-components';
import { Asset } from '../../../types/asset';
import { VLink } from '../../other/vLink';

const Button = ({ label, link }: { label: string; link: string }) => {
  const className = `text-black uppercase inline-block py-3 px-5 md:px-8 mr-4 bg-transparent text-md md:text-xl border border-stone mb-5`;
  return <VLink className={className} to={link}>{label}</VLink>;
};

const HeroContainer = styled.div`
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  min-height: 400px;
  padding: 35% 32px 0px 32px;

  @media (min-width: 1080px) {
    padding: 0 64px;
  }

  @media (min-width: 768px) {
    height: 60vh;
  }
`;

interface CaseStudyFullImageProps {
  image?: Asset;
}

export const CaseStudyFullImage: React.FC<CaseStudyFullImageProps> = ({
  image,
}) => {

  if (!image) {
    return null;
  }
  return (
    <HeroContainer
      className="relative flex flex-col justify-end text-black border-b sm:flex-row sm:justify-start sm:items-end border-stone"
      style={{
        backgroundImage: `url(${image.url})`,
      }}
    />
  );
};
